var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            "append-to-body": _vm.appendToBody,
            visible: _vm.dialogVisible,
            top: "20%",
            width: "30%",
            "show-close": false,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "hetdel" }, [
            _c(
              "div",
              { staticClass: "tubiao" },
              [
                _c("svg-icon", {
                  staticClass: "head",
                  attrs: { name: _vm.type },
                }),
              ],
              1
            ),
            _c("div", { staticClass: "rigtht" }, [
              _c("div", { staticClass: "tab1" }, [_vm._v(_vm._s(_vm.text))]),
              _c("div", { staticClass: "tab2" }, [
                _vm._v(_vm._s(_vm.$t("components.promptInformation.thanks"))),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "buton" }, [
            _c(
              "span",
              { staticClass: "butonmt sot", on: { click: _vm.butoe } },
              [
                _vm._v(
                  " " + _vm._s(_vm.$t("components.promptInformation.backHome"))
                ),
              ]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }